export const takeSearchParams = (take?: string | 'all' | null): number | 'all' | null => {
	if (take === 'all') {
		return take
	} else if (typeof take === 'string' && take.length > 0 && +take > 0) {
		return +take
	}
	return null
}
